import axios from 'axios'
import React, { useContext, useState } from 'react'
import AutoCompletePoI from 'src/components/autocomplete/AutocompletePoi'
import { IAddress } from 'src/Interface'
import Button from '../../../button/Button'
import styles from './add-address.module.scss'
import { IState } from 'src/Interface'
import { StateContext, } from '../../../../AppContext'
import { baseApiURL } from 'src/utils/utils'
import { toast } from 'react-toastify'
import { DispatchContext } from 'src/AppContext'
import Input from '../../../input/Input'
import { validString } from 'src/utils/utils'

interface IError {
  label:boolean
}
interface Props {
  branchId: number
  close: () => null
}


const AddAddressPOI: React.FunctionComponent<Props> = ({ close, branchId }: Props) => {
  const state: IState = useContext(StateContext)
  const dispatch = useContext(DispatchContext)
  const [address, setAddress] =  useState<IAddress>(null)
  const [errors, setErrors] = useState<IError>({
    label: false
  })

  const [validationErrors, setValidationErrors] = useState<IError>({
    label: false,
  })
  
  const resetError = (fieldName: string) => {
    setErrors({
      ...errors,
      [fieldName]: false
    })
    setValidationErrors({
      ...validationErrors,
      [fieldName]: false
    })
  }

  const handleValidation = (regexp: RegExp, fieldName: string) => (value: string) => {
    let error = false
    if (value && regexp && !regexp.test(value || '')) {
      error = true
    }

    setValidationErrors({
      ...validationErrors,
      [fieldName]: error
    })
  }
  const handleInputChange = (fieldName: string) => (value: any) => {
    if(fieldName==='address'){
      setAddress(value)
    }
    else if(fieldName==='label'){
      setAddress({...address, label:value})
    }
  }

  const createAddress = () => {
    axios.post(`${baseApiURL()}/branches/${branchId}/custom_addresses`, address, {
      headers: {
        Authorization:
          `Bearer ${state.user.accessToken}`
      }
    }).then((result) => {
      return result.data.customAddressId
    }).then((customAddressId) => {
      return axios(`${baseApiURL()}/branches/${branchId}/custom_addresses/${customAddressId}`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
    }).then((result: any) => {
      dispatch({ type: 'SET_CUSTOM_ADDRESSES', addresses: [result.data, ...state.customAddresses] })
      close()
    }).catch(err => {
      toast(err.response.data.message)
    })
  }

  return (
    <div className={styles.module}>
      <header className={styles.header}>
        <h4>Opret adresse</h4>
      </header>
      <div className={styles.container}>
      <AutoCompletePoI modifiers='tw-mb-3' setAddress={() => handleInputChange('address')} name='address' label='Adresse *' placeholder='Indtast adresse' />
      <div className='tw-mb-3'>
            <Input
              label='Label *'
              type='text'
              value={address?.label}
              error={errors.label || validationErrors.label}
              resetError={() => resetError('label')}
              handleValidation={() => handleValidation(validString, 'label')}
              handleInputChange={() => handleInputChange('label')}
              name='label'
              placeholder='Label'
            />
            {validationErrors.label && <p className='errorMsg'>bør kun bestå af tal og være mellem 1 og 6 karakterer.</p>}
            {errors.label && <p className='errorMsg'>Konto koden eksisterer allerede</p>}
          </div>
          <div className='tw-mb-3'>
            <Input
              readOnly
              label='POI'
              type='text'
              value={address?.poi}
              name='poi'
              placeholder='POI'
            />
          </div>
          <div className='tw-mb-3'>
            <Input
              readOnly
              label='Husnummer'
              type='text'
              value={address?.houseNo}
              name='houseNo'
              placeholder='Husnummer'
            />
          </div>

          <div className='tw-mb-3'>
            <Input
              readOnly
              label='Postnummer'
              type='text'
              value={address?.zipCode}
              name='zipCode'
              placeholder='Postnummer'
            />
          </div>

          <div className='tw-mb-3'>
            <Input
              readOnly
              label='Vejnavn'
              type='text'
              value={address?.streetName}
              name='streetName'
              placeholder='Vejnavn'
            />
          </div>
      </div>
      <footer className={styles.footer}>
        <Button type='secondary' label='Annuller' handleClick={close} />
        <Button  loading={false} type='primary' label='Opret adresse' handleClick={createAddress} />
      </footer>
    </div>
  )
}

export default AddAddressPOI
